module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n      云服务器\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "contentBox"
  }, [_c('div', {
    staticClass: "server-container"
  }, [(_vm.serverList.length > 0) ? _c('ul', {
    staticClass: "common-list-box"
  }, _vm._l((_vm.serverList), function(item, index) {
    return _c('li', {
      staticClass: "list-item",
      on: {
        "click": function($event) {
          _vm.ServerManage(item.id, item.Pstate)
        }
      }
    }, [_c('div', {
      staticClass: "item-info"
    }, [_c('div', {
      staticClass: "item-top"
    }, [(item.Pstate === '未初始化') ? _c('x-button', {
      staticStyle: {
        "margin-bottom": ".1rem"
      },
      attrs: {
        "mini": ""
      }
    }, [_vm._v("一键初始化")]) : _vm._e(), _vm._v(" "), (item.Pstate != '未初始化') ? _c('span', {
      staticClass: "item-name margin-right-30"
    }, [_vm._v(_vm._s(item.vps_name))]) : _vm._e(), _vm._v(" "), (item.state.loading != 'ok' && item.state.msg) ? _c('span', {
      staticClass: "server-state state-icon",
      class: {
        'state-icon-run text-success': item.state.msg.indexOf('运行') != -1, 'state-icon-stop text-fail': item.state.msg.indexOf('关机') != -1
      }
    }, [_vm._v(_vm._s(item.state.msg)), _c('span', {
      staticClass: "text-ash-black"
    }, [_vm._v("（" + _vm._s(item.Pstate) + "）")])]) : _vm._e(), _vm._v(" "), (item.state.loading === 'ok' && item.state.msg) ? _c('span', {
      staticClass: "server-state state-icon state-icon-loading text-orange"
    }, [_vm._v(_vm._s(item.state.loading_txt)), _c('span', {
      staticClass: "text-ash-black"
    }, [_vm._v("（" + _vm._s(item.Pstate) + "）")])]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "server-options-trigger",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.Bubble(index)
        }
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "row1"
    }, [_vm._v("[" + _vm._s(item.xianlu) + "]  " + _vm._s(item.ip))]), _vm._v(" "), (item.EndTime.indexOf('2111') != 0) ? _c('div', {
      staticClass: "row1"
    }, [_vm._v("[到期时间]  " + _vm._s(item.EndTime))]) : _vm._e(), _vm._v(" "), (item.EndTime.indexOf('2111') == 0) ? _c('div', {
      staticClass: "row1"
    }, [_vm._v("[到期时间]  终身VIP")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "item-icon system-icon",
      class: {
        'system-icon-windows': item.OsType_1 === 'Windows', 'system-icon-ubuntu': item.OsType_1 === 'Ubuntu', 'system-icon-centos': item.OsType_1 === 'CentOS'
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "server-manage-link",
      attrs: {
        "href": "javascript:;"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "bubble-box list-bubble links-container",
      class: {
        'active': index === _vm.bubbleIndex
      }
    }, [_c('a', {
      staticClass: "manage-btn",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.Mange(item.id)
        }
      }
    }, [_vm._v(" 管理")]), _vm._v(" "), _c('a', {
      staticClass: "renew-btn",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.Renew(item.id)
        }
      }
    }, [_vm._v(" 续费")]), _vm._v(" "), _c('a', {
      staticClass: "upgrade-btn",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.level(item.id, item.cpu, item.ram, item.disk, item.net)
        }
      }
    }, [_vm._v(" 升级")])])])
  })) : _vm._e(), _vm._v(" "), (_vm.serverList.length == 0) ? _c('div', {
    staticClass: "list-empty-box"
  }, [_vm._v("\n          当前没有相关云服务器\n        ")]) : _vm._e(), _vm._v(" "), (_vm.serverList.length > 0) ? _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "clearfix pager-wrapper"
  }, [_c('div', {
    staticClass: "pagination",
    attrs: {
      "id": "pager"
    }
  }, [_c('span', {
    staticClass: "page-button pager-prev",
    class: {
      disabled: _vm.pager.page == 1
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, 'up')
      }
    }
  }, [_vm._v("上一页")]), _vm._v(" "), _c('span', {
    staticClass: "page-info"
  }), _vm._v(" " + _vm._s(_vm.pager.page) + "/" + _vm._s(_vm.pager.count) + "\n              "), _c('span', {
    staticClass: "page-button pager-next",
    class: {
      disabled: _vm.pager.page == _vm.pager.count || _vm.pager.count == 0
    },
    on: {
      "click": function($event) {
        _vm.pageNum(_vm.pager.page, "down")
      }
    }
  }, [_vm._v("下一页")])])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ca0d54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/serverManage.vue
// module id = w2tu
// module chunks = 1